<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightpage" id="d7e9">
<p class="copyrighttext">Copyright © 2010 Simon and Schuster<br/> This book, or parts thereof, may not be reproduced in any<br/>form without permission from the publisher; exceptions are<br/>made for brief excerpts used in published reviews.</p>
<p class="copyrighttext">Published by<br/> Adams Media, an imprint of Simon &amp; Schuster, Inc.<br/> 57 Littlefield Street, Avon, MA 02322. U.S.A.<br/> <i><a href="http://www.adamsmedia.com" target="_blank">www.adamsmedia.com</a></i>
</p>
<p class="copyrighttext">ISBN 10: 1-60550-143-3<br/>
ISBN 13: 978-1-60550-143-7<br/>
eISBN 13: 978-1-4405-0696-3</p>
<p class="copyrighttext">Printed in the United States of America.</p>
<p class="copyrighttext">10 9 8 7 6 5 4 3 2 1</p>
<p class="copyrighttext"><b>Library of Congress Cataloging-in-Publication Data</b><br/>is available from the publisher.</p>
<p class="copyrighttext" style="text-align: left;">
<i><a href="http://SheKnows.com" target="_blank">SheKnows.com</a> Presents: The Best Sex of Your Life</i> is intended as a reference volume only. In light of the complex, individual, and specific nature of health conditions, this book is not intended to replace professional medical advice. The ideas, procedures, and suggestions in this book are intended to supplement, not replace, the advice of a trained professional. Consult your physician before adopting the suggestions in this book, as well as about any condition that may require diagnosis or medical attention. The author, <a href="http://SheKnows.com" target="_blank">SheKnows.com</a>, and publisher disclaim any liability arising directly or indirectly from the use of this book.</p>
<p class="copyrighttext" style="text-align: left;">This publication is designed to provide accurate and authoritative information with regard to the subject matter covered. It is sold with the understanding that the publisher is not engaged in rendering legal, accounting, or other professional advice. If legal advice or other expert assistance is required, the services of a competent professional person should be sought.</p>
<p class="copyrighttext" style="text-align: right;">— From a <i>Declaration of Principles</i> jointly adopted by a Committee of the American <br/>Bar Association and a Committee of Publishers and Associations</p>
<p class="copyrighttext" style="text-align: center;">
<i>This book is available at quantity discounts for bulk purchases.<br/> For information, please call 1-800-289-0963.</i>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9781440506963_epub_part1.vue?5dfb9bb0